import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import ReasonForContact from './ReasonForContact';
import RequestForm from './RequestForm';
import RelatedIssue from './IssueRelatedTo';
import LoadingSpinner from "../UI/LoadingSpinner";

const StepperForm = () => {
  const { appList } = useSelector((state) => state.app)

  const [isLoading, setIsLoading] = useState(false);
  const [activeStep, setActiveStep] = useState('RelatedIssue');
  const [isReasonOptionSelected, setIsReasonOptionSelected] = useState(false);
  const [value, setValue] = useState('');
  const [issueReason, setIssueReason] = useState('');
  const [supportAreas, setSupportAreas] = useState();

  const relatedIssueRef = useRef(null);
  const reasonForContactRef = useRef(null);
  const requestFormRef = useRef(null);

  useEffect(() => {
    if (activeStep === 'ReasonForContact') {
      reasonForContactRef.current.scrollIntoView({ behavior: 'smooth' });
    } else if (activeStep === 'RequestForm') {
      requestFormRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [activeStep]);

  const nextPage = (reason, categoryId) => {
    setValue(reason);
    const selectedAppDetail = appList.filter(app => app.nid === categoryId);
    const supportAreaList = selectedAppDetail[0]?.support_areas ? selectedAppDetail[0]?.support_areas.split(',') : '';
    setSupportAreas(supportAreaList);
    setActiveStep('ReasonForContact');
    setIssueReason('')
    setIsReasonOptionSelected(false)
  };

  const nextToFormSubmission = () => {
    setActiveStep('RequestForm');
  };

  return (
    <div className="grow">
      {isLoading && (
        <div className="parentDisable">
          <LoadingSpinner />
        </div>
      )}
      <section className="section supportSection">
        <div className="px-5 sm:px-5 md:px-5 lg:px-14 pt-5 pb-8 sm:pt-5 sm:pb-8 md:pt-5 md:pb-8 lg:py-8 h-full">
          <h2 className="text-[#333] barlowBold text-lg leading-8 sm:text-2xl sm:leading-9 uppercase tracking-[-0.25px]">Support</h2>
          <p className="text-[#333] text-base leading-6 sm:text-lg sm:leading-8 font-normal">Your opinion matters – tell us what you think!</p>
          <div ref={relatedIssueRef} >
            <RelatedIssue
              nextPage={nextPage}
              setIsLoading={setIsLoading}
              isLoading={isLoading}
            />
          </div>
          <div ref={reasonForContactRef} className={value ? "" : "disabled"}>
            <ReasonForContact
              value={value}
              setIssueReason={setIssueReason}
              issueReason={issueReason}
              supportAreas={supportAreas}
              nextToFormSubmission={nextToFormSubmission}
              setIsReasonOptionSelected={setIsReasonOptionSelected}
              isReasonOptionSelected={isReasonOptionSelected}
              setIsLoading={setIsLoading}
              isLoading={isLoading}
            />
          </div>
          <div ref={requestFormRef} className={value && issueReason ? "h-auto" : "disabled"}>
            <RequestForm
              setIsLoading={setIsLoading}
              setActiveStep={setActiveStep}
              value={value}
              issueReason={issueReason}
              isLoading={isLoading}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default StepperForm;
